import { SalesVsExpensesHistoricExpenses } from './sales-vs-expenses-historic';
import { DTabs } from '../../../dum';
import { SalesVsExpenses } from './sales-vs-expenses/sales-vs-expenses';

export function SalesVsExpensesHistoric() {
    return (
        <DTabs
            items={[
                {
                    title: 'Ventas vs Gastos ',
                    content: () => {
                        return <SalesVsExpenses />;
                    },
                },
                {
                    title: 'Ventas vs Gastos (Historico)',
                    content: () => {
                        return <SalesVsExpensesHistoricExpenses />;
                    },
                },
            ]}
        />
    );
}
